import dayjs from 'dayjs';

const TRAVEL_KEYWORDS = ['เดินทาง', 'ขับรถ', 'ขับมอเตอร์ไซค์'];
const SUNDAY = 0;

export default function CalOtRate(date, description) {
  if (TRAVEL_KEYWORDS.some((kw) => (description || '').includes(kw))) {
    return 1;
  }
  if (dayjs(date).day() === SUNDAY) {
    return 3;
  }
  return 1.5;
}
